import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

interface IExpiryRepeatWarningModalProps {
  open: boolean;
  onRetry: () => void;
  onConfirm: () => void | Promise<void>;
  confirmLoading?: boolean;
}

const ExpiryRepeatWarningModal: React.FC<IExpiryRepeatWarningModalProps> = ({
  open,
  onRetry,
  onConfirm,
  confirmLoading = false,
}) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[90]" onClose={onRetry}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-60 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-[90] w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="w-full max-w-xl rounded-lg bg-white p-6 text-left shadow-xl">
                <Dialog.Title className="text-base font-semibold text-[#202223]">Entered expiry does not match the available Inventory</Dialog.Title>
                <p className="mt-3 text-sm text-[#4B5563]">
                   You can proceed with this and trigger expiry correction audit, or enter the correct expiry date.
                </p>
                <div className="mt-6 flex justify-end gap-3">
                  <button
                    type="button"
                    className="rounded-md border border-[#D0D5DD] px-4 py-2 text-sm font-medium text-[#344054] hover:bg-[#F9FAFB]"
                    onClick={onRetry}
                    disabled={confirmLoading}
                  >
                    Change
                  </button>
                  <button
                    type="button"
                    className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
                      confirmLoading ? "bg-gray-400 cursor-not-allowed" : "bg-[#193A6A] hover:bg-[#0f2748]"
                    }`}
                    onClick={onConfirm}
                    disabled={confirmLoading}
                  >
                    {confirmLoading ? "Proceed..." : "Proceed"}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ExpiryRepeatWarningModal;
